import React from 'react'
// import Footer from 'src/views/website/landing/components/Footer'
// import Header from 'src/views/website/landing/components/Header'

const GuestLayout = ({children}) => {
  return (
    <>
    {/* <Header /> */}
    {children}
    {/* <Footer /> */}
    </>
  )
}

export default GuestLayout